module.exports = __webpack_public_path__ + "images/assets/5f73f8733c9b5297005c38da3c721595.svg";